import { Component, OnInit } from '@angular/core';
import { UserService } from '@lru/felib';

@Component({
  selector: 'portal-header-course',
  templateUrl: './header-course.component.html',
  styleUrls: ['./header-course.component.scss'],
})
export class HeaderCourseComponent implements OnInit {
  isLoggedIn?: boolean;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.isLoggedIn = this.userService.isLoggedIn;
  }
}
